import React from "react";

const TextSnippetIcon = ({className}) => (
    <svg className={className} xmlns="http://www.w3.org/2000/svg" width="21" height="24" viewBox="0 0 21 24">
        <path id="Customized_Icon" data-name="Customized Icon" d="M0,0V24H21V12H9V0ZM12,0V9h9ZM3,6H6V9H3Zm0,6H6v3H3Zm0,6H15v3H3Z" />
    </svg>
);

export default TextSnippetIcon;
